declare namespace $ {

	type $mol_view__sub_bog_card_contact_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_bog_card_contact_2 = $mol_type_enforce<
		ReturnType< $bog_card_contact['name'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_card_contact_3 = $mol_type_enforce<
		ReturnType< $bog_card_contact['username'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_bog_card_contact_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_card_contact extends $mol_link {
		Contact_svg( ): $bog_card_icon_telegram
		Contact_icon( ): $mol_view
		name( ): string
		Contact_name( ): $mol_text
		username( ): string
		Contact_handle( ): $mol_text
		Contact_info( ): $mol_view
		Contact_arrow( ): $bog_card_icon_arrow
		uri( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=contact.view.tree.d.ts.map